// paste.service.ts
import { INotesComponent } from '@modeso/types__aumico-lib-annualreport-be';
import { AumicoClipboardData } from '../interfaces/aumico-clipboard-data.interface';

export interface PasteContext {
    targetClientId: string;
    targetProjectId: string;
}

export class AumicoPasteService {
    constructor() {}

    /** Main entry: returns a brand new, clean table data ready to persist/render */
    paste(envelope: AumicoClipboardData): INotesComponent {
        const data = envelope.component;

        // Validate type
        if (data.componentName !== envelope.componentType) {
            throw new Error('Clipboard componentType mismatch');
        }

        // Deep clone to avoid reference leakage
        const clone = JSON.parse(JSON.stringify(data)) as typeof data;

        return clone;
    }
}
